import {
  getSignatureConfig,
  isValidationFulfilled,
} from 'pages/FormProcess/DynamicForm/Containers/DynamicViewer/components/FieldRenderer/Fields/helper';

import { useSelector } from 'react-redux';
import {
  getDynamicFormSelector,
  getDynamicFormSignatureConfigSelector,
} from 'store/selectors/requestFormProcess';

export const useManageQuestions = () => {
  const { showWizard, activeQuestions, responses } = useSelector(
    getDynamicFormSignatureConfigSelector,
  );

  const { bundleDocumentsDetails = [] } = useSelector(getDynamicFormSelector);

  const { questions: allQuestions, answers } = getSignatureConfig({
    bundleDocumentsDetails,
    activeQuestions,
    responses,
    showWizard,
  });

  const questions = allQuestions.filter((ques) => !ques.disabled);

  const getAnswersCount = () => {
    const formQuestions = [...questions];
    const groupedRadioQuestions: Record<number, any> = [];
    const nonRadioQuestions: any[] = [];

    const isAnswered = (uuid: string) => !!answers?.[uuid]?.Answer;

    for (const question of formQuestions) {
      const { UUID, Type, QuestionValidationId, Required, QuestionValidation } = question;

      if (Type === 'Radio Group' && QuestionValidationId) {
        if (!groupedRadioQuestions[QuestionValidationId]) {
          groupedRadioQuestions[QuestionValidationId] = {
            QuestionValidationId,
            GroupField: QuestionValidation?.GroupField,
            Items: [],
            Required,
            validationsFulfilled: isValidationFulfilled(
              formQuestions,
              QuestionValidationId,
              answers,
            ),
          };
        }

        groupedRadioQuestions[QuestionValidationId].Items.push({ UUID });
      } else {
        nonRadioQuestions.push({ UUID, Required });
      }
    }

    const radioGroups = Object.values(groupedRadioQuestions);
    const allQuestions = [...radioGroups, ...nonRadioQuestions];

    const totalQuestions = allQuestions.length;

    const requiredQuestions = allQuestions.filter((q) => q.Required);
    const totalRequiredQuestions = requiredQuestions.length;

    const filledQuestions = formQuestions.filter((q) => isAnswered(q.UUID)).length;

    const filledRequiredQuestions = requiredQuestions.reduce((count, q) => {
      if (q.Items?.length) {
        const allUnanswered = q.Items.every((item) => !isAnswered(item.UUID));
        return count + (allUnanswered ? 0 : 1);
      } else {
        return count + (isAnswered(q.UUID) ? 1 : 0);
      }
    }, 0);

    let isAllValidationFulfilled = true;

    if (radioGroups.length) {
      isAllValidationFulfilled = Boolean(
        radioGroups.every(({ validationsFulfilled }) => validationsFulfilled),
      );
    }

    return {
      totalQuestions,
      totalRequiredQuestions,
      filledQuestions,
      filledRequiredQuestions,
      isAllValidationFulfilled,
    };
  };

  return {
    ...getAnswersCount(),
  };
};
